export default __webpack_public_path__ + "static/axicube-company-desk-a40f649f90deeac250a7e9dc6d2c298f.pdf";